import _ from 'lodash'
import { AppIcon  } from '@/shared/ui/icons'
import { DateTime } from 'luxon'

import { useDigitalProductContext } from '@/shared/contexts/DigitalProductContext'
import { useResourceRecordsContext } from '@/shared/hooks'
import { Card } from '@/shared/ui'


export const DigitalProductLiveStreamsCard = ({
  id,
  uid,
  name,
  image,
  start_at,
  end_at,
  point_reward,
  coin_reward
}) => {
  const { getLiveStreamsProgress, basePathWithId } = useDigitalProductContext()
  const {
    config: { getStatus, getSubliveStreamStatus, basePath }
  } = useResourceRecordsContext()
  const status = getStatus({ start_at, end_at })

  return (
    <Card href={`${basePath}/${uid}`} className="h-full">
      <Card.Body className="p-6 flex flex-col">
        <div className="group relative mb-4">
          <div
            className="h-[200px] rounded-lg bg-cover bg-center bg-no-repeat bg-brand"
            style={{
              backgroundImage: `url(${_.get(
                image,
                'file.url',
                '/placeholders/liveStream.jpg'
              )})`
            }}
          />
          <div className="absolute inset-0 flex items-center justify-center rounded-lg bg-dark/25 opacity-0 transition-opacity group-hover:opacity-100">
            <AppIcon name="play" size={48} className="text-white" />
          </div>
        </div>
        <span className="font-bold text-gray-800 cursor-pointer hover:text-brand text-base block">
          {name}
        </span>
      </Card.Body>
    </Card>
  )
}
